import styled from 'styled-components';
import { device } from 'common/constants/mediaQueries';

export const modalContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  opacity: 0;

  &.show {
    visibility: visible;
    opacity: 1;
  }

  &.absolute {
    position: absolute;
  }

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--z-modal);
  }

  &.center {
    align-items: center;
  }
`;

/*
 * The dialog is a card, drawn the way every other card in the panel is drawn:
 * `--surface` on `--r-md` under `--sh-2`, not the old 12px radius with a flat
 * white ground and no elevation at all.
 *
 * Padding is `--s5` on the body with the head rule doing the separating. It
 * used to be `40px 30px` — two values on no scale, which is why every call
 * site that wanted a smaller dialog passed its own `padding` through `style`.
 * Those overrides still win where they are set; they should come off as each
 * screen is opened.
 */
export const modalPaper = styled.div`
  width: 100%;
  max-width: 600px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  box-shadow: var(--sh-2);
  visibility: hidden;
  opacity: 0;
  z-index: 11;
  position: absolute;
  transition:
    opacity 0.16s,
    transform 0.16s;
  padding: var(--s5);
  transform: scale(0.97);

  &.show {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
  }

  &.center {
    position: static;
  }

  @media ${device.tablet} {
    width: 90%;
  }
`;

export const back = styled.div`
  background: var(--scrim);
  width: 100%;
  height: 100%;
  position: absolute;
`;

/* The design's section head, minus the card edge: 13/600 over a hairline. */
export const title = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--fs-body);
  font-weight: var(--fw-semibold);
  letter-spacing: -0.005em;
  color: var(--text);
  padding-bottom: var(--s3);
  margin-bottom: var(--s4);
  border-bottom: 1px solid var(--line);
`;

/* The design's `.icon-btn`, parked in the corner. */
export const closeBtn = styled.button`
  position: absolute;
  right: var(--s3);
  top: var(--s3);
  width: var(--h-btn-sm);
  height: var(--h-btn-sm);
  display: grid;
  place-items: center;
  border: none;
  border-radius: var(--r-sm);
  background: none;
  color: var(--text-faint);
  cursor: pointer;
  line-height: 0;

  &:hover {
    background: var(--surface-alt);
    color: var(--text);
  }

  svg {
    width: 15px;
    height: 15px;
    stroke-width: 1.9;
  }
`;

export const img = styled.img``;
